













































import {Component, Vue} from "vue-property-decorator"
import Gravatar from "@/components/Gravatar.vue"
import {vxm} from "@/store"
import {User} from "@/interface"

@Component({components: {Gravatar}})
export default class SideBar extends Vue {

  private me: User | null = null

  private common_menus = [
    {type: "header", text: "MAIN"},
    {type: "link", text: "NOTIFICATIONS", icon: "mdi-bell", link: {name: "NotificationList"}},
    {type: "header", text: "REPORTS"},
    {type: "link", text: "TOKENS TRANSITION", icon: "mdi-chart-bar", link: {name: "ReportToken"}},
    {type: "link", text: "CTR TRANSITION", icon: "mdi-chart-line", link: {name: "ReportCTRTransition"}},
    {type: "link", text: "NOTIFICATIONS DATA", icon: "mdi-table", link: {name: "ReportNotification"}},
    {type: "header", text: "PROFILE"},
    {type: "link", text: "EDIT PROFILE", icon: "mdi-account", link: {name: "EditProfile"}},
    {type: "link", text: "CHANGE PASSWORD", icon: "mdi-key-variant", link: {name: "ChangePassword"}}
  ]

  private admin_menus = [
    {type: "header", text: "ADMIN"},
    {type: "link", text: "SITES", icon: "mdi-earth", link: {name: "AdminSiteList"}},
    {type: "link", text: "USERS", icon: "mdi-account-multiple", link: {name: "AdminUserList"}},
    {type: "header", text: "DEBUG"},
    {type: "link", text: "TEST PUSH", icon: "mdi-bell", link: {name: "DebugTestPush"}}
  ]

  get menus() {
    if (vxm.auth.isAdmin) {
      return this.common_menus.concat(this.admin_menus)
    } else {
      return this.common_menus
    }
  }

  get isAuth() {
    return vxm.auth.isAuth
  }

  get show() {
    return vxm.ui.show_menu
  }

  async mounted() {
    this.me = vxm.auth.user
  }

  async signOut() {
    await vxm.auth.signout()
  }

  async onClickLink() {
    await vxm.ui.hideSideNavi()
  }
}
